import Vue from 'vue';
import _store from '@/store';

export {_store as store};

//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Variable                                                              //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//
export const state = {
  store: _store.state,
  // States from Vuex store
  local: Vue.observable({
    // Setup local state here (States which don't shared or long-term keeping);

    isProcessing: false,

    //manual data
    selectedDegree: null,
    selectedSubjectGroup: null,
    selectedSubject: null,
    selectedTeacher: null,
    selectedAcademicPeriod: null,
    currentAcademicPeriod: null,
    subjects: [],
    advisorOnlineSchedules: [],
    showWarningNoClassRoom: false,

    //classRoom edit
    classRoomEdit: {
      selectedClassRoom: null,
      selectedCourseOutlineUnit: null,

      classRooms: [],
      courseOutlineUnits: [],
    },

    //subject info
    subjectInfo: {
      classSection: null
    },

    // teacher edit
    teacherEdit: {
      selectedTeacher: null
    },

    //edit page
    advisorOnlineScheduleEdit: {
      id: '',
      form: {
        advisorOnlineScheduleInput: {
          periodCode: '',
          degreeCode: '',
          subjectGroupCode: '',
          subjectCode: '',
          subjectName: '',
          teacherCode: '',
          sectionNo: '',
          teacherFullName: '',
          topicLocal: '',
          topicEng: '',
          descriptionLocal: '',
          descriptionEng: '',
          dateTimeFrom: new Date(),
          dateTimeTo: new Date(),
          remark: '',
          externalLink: '',
          externalPassword: '',
          isEnabled: true,
        },
      },
      selectedHourFrom: null,
      selectedMinuteFrom: null,
      selectedHourTo: null,
      selectedMinuteTo: null,
      hour: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09'
        , '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
      minute: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09'
        , '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'
        , '20', '21', '22', '23', '24', '25', '26', '27', '28', '29'
        , '30', '31', '32', '33', '34', '35', '36', '37', '38', '39'
        , '40', '41', '42', '43', '44', '45', '46', '47', '48', '49'
        , '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'
      ],
      showWaringDate: false,
    },


  })
};

export const template = {
  table: {
    header: [
      // {title: 'live-class-schedule.no', id: 'no'},
      {title: 'live-class-schedule.subject-code', id: 'subjectCode', width: 200},
      // {title: 'live-class-schedule.subject-name', id: 'subjectName'},
      {title: 'advisor-online-schedule.meet-date', id: 'onAirTtime', width: 200},
      {title: 'live-class-schedule.teacher', id: 'teacher', width: 250},
      // {title: 'live-class-schedule.section', id: 'classSectionQty'},
      // {title: 'live-class-schedule.unit', id: 'courseOutlineUnit'},
      {title: 'live-class-schedule.topic', id: 'topic', width: 250},
      {title: 'live-class-schedule.remark', id: 'remark', width: 200},
      {title: 'live-class-schedule.is-enabled', id: 'isEnabled', width: 100},
      {title: '', id: ''},
    ]
  },
};


//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Function                                                              //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//

export const initData = async (func) => {
  //use state
  if (func.getAcademicPeriods && (!state.store.AcademicPeriod.academicPeriods || state.store.AcademicPeriod.academicPeriods.length === 0)) {
    await func.getAcademicPeriods();
  }
  if (func.getDegrees && (!state.store.Degree.degrees || state.store.Degree.degrees.length === 0)) {
    await func.getDegrees();
  }
  if (func.getSubjectGroups && (!state.store.SubjectGroup.subjectGroups || state.store.SubjectGroup.subjectGroups.length === 0)) {
    await func.getSubjectGroups();
  }
  if (func.getTeachersDdl && (!state.store.Teacher.teachers || state.store.Teacher.teachers.length === 0)) {
    await func.getTeachersDdl();
  }

  //use local
  if (func.getCurrentAcademicPeriodConfig && !state.local.academicPeriodConfig) {
    state.local.currentAcademicPeriod = await func.getCurrentAcademicPeriodConfig();
    state.local.selectedAcademicPeriod = state.store.AcademicPeriod.academicPeriods.find(item => {
      return item.periodCode === state.local.currentAcademicPeriod.learnPeriodCode
    });
  }

};

export const loadData = async (func) => {
  let payload = {
    advisorOnlineScheduleFilterInput: {
      academicPeriodId: state.local.selectedAcademicPeriod ? state.local.selectedAcademicPeriod.id : '',
      degreeId: state.local.selectedDegree ? state.local.selectedDegree.id : '',
      subjectGroupId: state.local.selectedSubjectGroup ? state.local.selectedSubjectGroup.id : '',
      subjectId: state.local.selectedSubject ? state.local.selectedSubject.id : '',
      teacherId: state.local.selectedTeacher ? state.local.selectedTeacher.id : '',
    }
  };
  if (func.getAdvisorOnlineSchedulesByFilterForTable) {
    state.local.advisorOnlineSchedules = await func.getAdvisorOnlineSchedulesByFilterForTable(payload);
  }

};

export const getClassSectionById = async (func) => {
  if (func.getClassSection) {
    if (state.local.classRoomEdit.selectedClassRoom) {
      state.local.subjectInfo.classSection =
        await func.getClassSection({
          id: state.local.classRoomEdit.selectedClassRoom.classSection.id
        });
    }
  }
}

//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Private Function                                                      //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//
